import Swiper, { Autoplay, Pagination } from "swiper";
import { CountUp } from 'countup.js';
import Masonry from 'masonry-layout';
import tippy from 'tippy.js';
import AOS from 'aos';
import { Modal } from "bootstrap";

window.addEventListener("load", function () {
   var mapLoaded = false;

   //AOS
   AOS.init({
      once: true
   });

   //Navigation
   const navToggle = document.getElementById("navToggle");
   const navigation = document.getElementById("navigation");
   const navOverlay = document.getElementById("navOverlay");
   const body = document.body;

   function openNavigation() {
      body.classList.add('overflow');
      navToggle.classList.add('navbar__toggle--active');
      navToggle.setAttribute('aria-expanded', 'true');
      navigation.classList.add('navigation--active');
      navOverlay.classList.add('navigation-overlay--active');
   }

   function closeNavigation() {
      body.classList.remove('overflow');
      navToggle.classList.remove('navbar__toggle--active');
      navToggle.setAttribute('aria-expanded', 'false');
      navigation.classList.remove('navigation--active');
      navOverlay.classList.remove('navigation-overlay--active');
   }

   navToggle.addEventListener('click', () => {
      if (navigation.classList.contains('navigation--active')) {
         closeNavigation();
      } else {
         openNavigation();
      }
   });

   navOverlay.addEventListener('click', () => {
      closeNavigation();
   });

   const navSublists = document.querySelectorAll('.navigation__sublist');

   navSublists.forEach(function (navSublist) {
      const navMore = navSublist.parentNode.children[1];
      const navSublistParent = navSublist.parentNode;

      navMore.addEventListener('click', () => {
         if (navSublistParent.classList.contains('navigation__item--active')) {
            navSublistParent.classList.toggle('navigation__item--toggle-active');
         } else {
            navSublistParent.classList.toggle('navigation__item--toggle');
         };
      });
   });


   //Map Trigger
   const mapToggle = document.getElementById("mapToggle");
   const mapOverlay = document.getElementById("mapOverlay");
   const mapTrigger = document.querySelectorAll(".map-trigger, a[href='#open-map'], a[href='#sonderpreis']");
   const vueMap = document.querySelector('my-vue-app');

   function openMap(projectId = null) {
      if(!mapLoaded) {
         // var mapVendorsScript = document.createElement('script');
         // mapVendorsScript.src = mapVendorsPath;
         // document.body.appendChild(mapVendorsScript);

         // var mapIndexScript = document.createElement('script');
         // mapIndexScript.src = mapIndexPath;
         // document.body.appendChild(mapIndexScript);

         // mapLoaded = true;
      }
      console.log('projectId', projectId);

      body.classList.add('overflow');
      mapOverlay.classList.add('map-overlay--active');

      setTimeout(function () {
         window.dispatchEvent(new Event('resize'));

         if(projectId) {
            vueMap.showPoiById(projectId);
         }
      }, 100)
   }

   function closeMap() {
      body.classList.remove('overflow');
      mapOverlay.classList.remove('map-overlay--active');
   }

   mapTrigger.forEach(trigger => {
      trigger.addEventListener('click', event => {
         event.preventDefault();

         if (mapOverlay.classList.contains('map-overlay--active')) {
            closeMap();
         } else {
            let projectId = trigger.dataset.project;
            if(trigger.getAttribute('href') === '#sonderpreis') {
               projectId = 'register-9898';
            }
            openMap(projectId);
         }
      });
   });

   if (typeof (mapToggle) !== 'undefined' && mapToggle !== null) {
      mapToggle.addEventListener('click', () => {
         closeMap();
      });
   }


   //Swiper Teaser Numbers
   const allSlides = document.querySelectorAll('.swiper-numbers .swiper-slide');
   const swiperNumbers = new Swiper(".swiper-numbers", {
      modules: [Autoplay, Pagination],
      slidesPerView: 1,
      autoplay: allSlides.length > 1 ? {
         delay: 7500
      } : false,
      loop: allSlides.length > 1 ? true : false,
      pagination: {
         el: ".swiper-numbers-pagination",
         clickable: true,
      }
   });

   swiperNumbers.autoplay.stop();


   //Countupjs Numbers
   const numberTeaser = document.querySelector('.teaser--numbers');
   const numberElements = document.querySelectorAll('.swiper-numbers__title');

   if (numberElements) {
      numberElements.forEach(function (numberElement) {
         const countOptions = {
            separator: '.',
            duration: 2.5,
         };

         let numberData = numberElement.dataset.number;
         let countUp = new CountUp(numberElement, numberData, countOptions);


         //IntersectionObserver for Number Teaser
         const observeOptions = {
            root: null,
            threshold: .75,
            // rootMargin: "-150px"
         };

         const observerNumbers = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
               if (!entry.isIntersecting) {
                  return;
               } else {
                  // console.log(entry);
                  swiperNumbers.autoplay.start();
                  countUp.start();
                  observerNumbers.unobserve(entry.target);
               }
            });
         }, observeOptions);

         observerNumbers.observe(numberTeaser);

         //Count Numbers on slide
         swiperNumbers.on('slideChange', function () {
            countUp.reset();
            countUp.start();
         });
      });

   }


   //Swiper Gallery
   const swiperGallery = new Swiper(".swiper-gallery", {
      modules: [Autoplay, Pagination],
      slidesPerView: 1,
      spaceBetween: 30,
      autoHeight: true,
      pagination: {
         el: ".swiper-gallery-pagination",
         clickable: true,
      }
   });


   //Masonry grid 
   var masonryElement = document.querySelector('.grid-msnry');
   if (typeof (masonryElement) !== 'undefined' && masonryElement !== null) {
      var msnry = new Masonry('.grid-msnry', {
         itemSelector: '.grid-msnry__item',
      });
   }


   //Tippy Sharing
   tippy('.tt', {
      content(reference) {
         const id = reference.getAttribute('data-template');
         const template = document.getElementById(id);
         return template.innerHTML;
      },
      trigger: 'click',
      allowHTML: true,
      maxWidth: 300,
      offset: [10, -25],
      arrow: false,
      placement: 'bottom-end',
      interactive: true
   });

   tippy('.tt-simple', {
      trigger: 'click',
      allowHTML: true
   });


   //History Back
   var backButton = document.getElementById('go-back');
   if (backButton) {
      document.getElementById('go-back').addEventListener('click', () => {
         history.back();
      });
   }

   // Tooltip

}, false);

// Modal content

const modalPreview = document.getElementById('modal-preview')
if (modalPreview) {
  modalPreview.addEventListener('show.bs.modal', event => {
    const trigger = event.relatedTarget
    
    const title = trigger.getAttribute('data-modal-title')
    const url = trigger.getAttribute('data-modal-url')
    const fileId = trigger.getAttribute('data-modal-fileid')

    // Update the modal's content.
    const modalTitle = document.getElementById('modal-preview-title')
    const modalDownload = document.getElementById('modal-preview-download')
    const modalPreviewItem = document.getElementById(`modal-preview-item-${fileId}`)

    modalTitle.textContent = title
    modalDownload.setAttribute('href', url)

    
    if (modalPreviewItem) {
      modalPreview.querySelectorAll('.modal-preview__item').forEach(item => {
        item.classList.remove('active')
      })

      modalPreviewItem.classList.add('active')
    }
  })
}

// Reset session storage so the map filter is not applied

sessionStorage.removeItem('isIframe')
sessionStorage.removeItem('blz')
